import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

type LoadingScreenProps = {
    label?: string;
    fullScreen?: boolean;
    className?: string;
};

/**
 * Full-screen or inline loading state.
 *
 * - `fullScreen` (default) covers the viewport with a soft backdrop.
 * - Use inline (`fullScreen={false}`) inside content areas.
 */
export function LoadingScreen({
    label = "Loading…",
    fullScreen = true,
    className,
}: LoadingScreenProps) {
    return (
        <div
            role="status"
            aria-live="polite"
            data-testid="loading-screen"
            className={cn(
                "flex flex-col items-center justify-center gap-4",
                fullScreen
                    ? "fixed inset-0 z-50 bg-background/90 backdrop-blur-sm"
                    : "w-full py-10",
                className,
            )}
        >
            <div className="relative flex h-14 w-14 items-center justify-center">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand/30" />
                <span className="relative inline-flex h-10 w-10 items-center justify-center rounded-full bg-brand text-white shadow-brand">
                    <Loader2 className="h-5 w-5 animate-spin" />
                </span>
            </div>
            <p className="text-sm font-medium text-muted-foreground">{label}</p>
        </div>
    );
}

export default LoadingScreen;
